export default __webpack_public_path__ + "static/media/Inspection_job_report.bc0f8c35.svg";